<template>
  <div
    :ref="name"
    class="nx-form-schedule-wrapper pb-3"
  >
    <nx-relation-editor-toolbar :title="label">
      <div slot="actions">
        <v-switch
          v-model="hasSchedule"
          :disabled="disabled"
        />
      </div>
    </nx-relation-editor-toolbar>

    <v-slide-y-transition>
      <v-layout v-show="hasSchedule">
        <v-flex xs12>
          <nx-date-time-picker
            v-validate="effectiveValidation"
            :data-vv-name="name"
            :data-vv-scope="scope"
            :data-vv-as="label"
            data-vv-value-path="value"
            data-vv-validate-on="input"
            :disabled="disabled"
            :value="value"
            :name="name"
            :min-date="effectiveMinDate"
            :max-date="effectiveMaxDate"
            v-bind="$attrs"
            @input="onInput"
            @blur="onBlur"
            @focus="onFocus"
          />
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </div>
</template>
<script>
import moment from 'moment';
import FormElement from '@/modules/form/mixins/form-element';
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar.vue';

export default {
  name: 'NxFormSchedule',
  components: {
    NxRelationEditorToolbar,
    NxDateTimePicker: () => import('@/components/date/DateTimePicker'),
  },
  mixins: [FormElement],
  props: {
    formValue: {
      type: Object,
    },
    minDate: {
      type: String,
    },
    minDateFromField: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    maxDateFromField: {
      type: String,
    },
  },
  computed: {
    effectiveMinDate() {
      if (this.minDate) {
        return this.minDate;
      }
      if (this.minDateFromField) {
        if (typeof this.formValue[this.minDateFromField] !== 'undefined') {
          return this.formValue[this.minDateFromField];
        }
        console.warn('Invalid minDateField configuration');
      }
      return undefined;
    },
    effectiveMaxDate() {
      if (this.maxDate) {
        return this.maxDate;
      }
      if (this.maxDateFromField) {
        if (typeof this.formValue[this.maxDateFromField] !== 'undefined') {
          return this.formValue[this.maxDateFromField];
        }
        console.warn('Invalid maxDateField configuration');
      }
      return undefined;
    },
    effectiveValidation() {
      const required = this.validation ? this.validation.required || false : false;
      let ret = {
        required,
      };

      if (this.effectiveMinDate) {
        ret = {
          ...ret,
          validateWithMinDate: this.effectiveMinDate,
        };
      }

      if (this.effectiveMaxDate) {
        ret = {
          ...ret,
          validateWithMaxDate: this.effectiveMaxDate,
        };
      }

      return ret;
    },
    defaultDate() {
      if (this.default) {
        return moment(this.default).format();
      }
      return moment().endOf('day').set({ s: 0 }).format();
    },
    hasSchedule: {
      get() {
        return Boolean(this.value);
      },
      set(hasSchedule) {
        const value = hasSchedule ? this.defaultDate : null;

        // Force channel touched flags
        this.$validator.flag(`${this.scope}.${this.name}`, {
          touched: true,
          dirty: true,
        });

        this.onInput(value);
      },
    },
  },
  methods: {
    onDefault(defaultValue) {
      // override default method
    },
    onInput(newValue) {
      this.$parentForm.updateField(this.name, newValue);
      this.$nextTick(this.validate);
    },
    onBlur() {
      this.flags.focused = false;
    },
    onFocus() {
      this.flags.focused = true;
    },
  },
};
</script>
